import React, { Fragment, useState, useEffect } from 'react';
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  tableCellClasses,
  Paper,
  IconButton,
  Dialog,
} from '@mui/material';
import ClientServices from 'services/Client';
import InputField from 'components/Input';
import DatePicker from 'components/DatePicker';
import { PrimaryButton } from 'components/Buttons';
import Colors from 'assets/Style/Colors';
import { FontFamily } from 'assets';
import SelectField from 'components/Select';
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";


import { Delete } from "@mui/icons-material";
import EditIcon from '@mui/icons-material/Edit';
import { CancelOutlined } from "@mui/icons-material";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { ErrorToaster, SuccessToaster } from "components/Toaster";

const Row = styled(TableRow)({ border: 0 });
const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",
    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
  },
});

// const useStyles = {
//   tableHeader: {
//     backgroundColor: '#f5f5f5',
//     fontWeight: 'bold',
//   },
//   tableCell: {
//     textAlign: 'center',
//   },
//   notesTextArea: {
//     width: '100%',
//     marginTop: '20px',
//   },
// };

const UpdatePrepaidAuctionCharges = () => {
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const [selectedVin, setSelectedVin] = useState('');
  const [rows, setRows] = useState([]);
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    notes: '',
    date: '',
    vehicles: [],
  });
  const [selectedPaidBy, setSelectedPaidBy] = useState(null);
  const { register, formState: { errors } } = useForm();
  const [isSearching, setIsSearching] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState(
    location.state?.selectedRows || []
  );
  const { id } = useParams();
  const [originalData, setOriginalData] = useState([]); // Store the original unfiltered data
  const [filteredRows, setFilteredRows] = useState([]); // This will hold the filtered results
  const navigate = useNavigate();


  const UpdateSLPVehicles = async () => {

    const row = rows[0];

    const params = {
      slp_id: row?.id || id,
      booking_id: row?.booking?.id,
      late_payment: parseFloat(row?.late_payment) || 0,
      storage: parseFloat(row?.storage) || 0,
      courier_charges: parseFloat(row?.courier_charges) || 0,
      date: formData.date || new Date(),
      notes: row?.notes || '',
      paid_by: selectedPaidBy?.name,
      shipping_vendor: row?.booking?.shipping_vendor,

    };

    try {
      setLoading(true);
      const response = await ClientServices.updateSLPVehicles(params);

      console.log("Update API Response", response);
      navigate('/prepaid-auction-charges-list')


      if (response.success) {
        SuccessToaster('Data updated successfully!');
      }
    } catch (error) {
      console.error('Error updating vehicles:', error);
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };


  const getAllSLPVehicles = async () => {
    try {

      let params = { slp_id: id };
      const { data } = await ClientServices.SLPVehiclesDetails(params);
      console.log(data, 'data')

      setOriginalData(data);
      setFilteredRows(data);
      if (data?.slp?.rows?.[0]?.date) {
        const apiDate = new Date(data?.slp?.rows?.[0]?.date);
        setSelectedDate(apiDate);
        setFormData((prev) => ({
          ...prev,
          date: apiDate.toLocaleDateString('en-CA'),
        }));
      }

      setRows(data?.slp?.rows);

      const paidById = data?.slp?.rows?.[0]?.paid_by === "Vendor" ? "vendor" : "vbl";
      console.log(paidById, 'paidById')
      setSelectedPaidBy({
        id: paidById,
        name: data?.slp?.rows?.[0]?.paid_by, 
      });
    
    } catch (error) {
      console.log(error);
    }
  };

  console.log(selectedPaidBy, 'selectedPaidBy')


  const getAllVehicles = async () => {
    try {
      const { data } = await ClientServices.getSLPVehicles();
      console.log("data", data)
      setVehicles(data.vehicles);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getAllSLPVehicles();
    getAllVehicles();
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFormData((prev) => ({
      ...prev,
      date: date.toLocaleDateString('en-CA'),
    }));
  };

  const handleEditClick = (row) => {
    setSelectedRows(row);
    setOpenEditModal(true);
    setNotes((prev) => ({ ...prev, [row.id]: row?.notes || '' }));
  };


  const handleLPSChange = (id, value) => {
    const updatedRows = rows.map((row) =>
      row.id === id ? {
        ...row,
        late_payment: value,
        total: (parseFloat(value) || 0) + (parseFloat(row.storage) || 0) + (parseFloat(row.courier_charges) || 0)
      } : row
    );
    setRows(updatedRows);
  };

  const handleSTGSChange = (id, value) => {
    const updatedRows = rows.map((row) =>
      row.id === id ? {
        ...row,
        storage: value,
        total: (parseFloat(row.late_payment) || 0) + (parseFloat(value) || 0) + (parseFloat(row.courier_charges) || 0)
      } : row
    );
    setRows(updatedRows);
  };

  const handleCourierChargesChange = (id, value) => {
    const updatedRows = rows.map((row) =>
      row.id === id ? {
        ...row,
        courier_charges: value,
        total: (parseFloat(row.late_payment) || 0) + (parseFloat(row.storage) || 0) + (parseFloat(value) || 0)
      } : row
    );
    setRows(updatedRows);
  };


  const handleNotesChange = (e) => {
    const { value } = e.target;
    setNotes((prev) => ({
      ...prev,
      [selectedRows.id]: value,
    }));
  };

  const handleSaveNotes = () => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === selectedRows.id
          ? { ...row, notes: notes[selectedRows.id] }
          : row
      )
    );
    setOpenEditModal(false);
  };

  const handleDelete = (vin) => {
    const updatedRows = rows.filter((row) => row?.booking?.vin !== vin);
    setRows(updatedRows);
  };

  console.log(rows, 'rows')


  return (
    <Fragment>
      <Dialog
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        sx={{
          "& .MuiDialog-paper": {
            width: "30%",
            height: "auto",
            borderRadius: 2,
            py: { xs: 2, md: 4 },
            px: { xs: 3, md: 6 },
          },
        }}
      >
        <IconButton
          onClick={() => setOpenEditModal(false)}
          sx={{ position: "absolute", right: 13, top: 13 }}
        >
          <CancelOutlined />
        </IconButton>
        <Box component={"form"}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
            Notes
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={1}
            value={notes[selectedRows?.id] ?? ""}
            onChange={handleNotesChange}
            placeholder="Enter notes"
          />

          <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 2 }}>
            <PrimaryButton title="Submit" onClick={handleSaveNotes} />
          </Box>
        </Box>
      </Dialog>


      <Grid container spacing={1} alignItems={'center'} justifyContent={'center'}>
        <Grid item xs={12} sm={12} md={11}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              mr: 4,
              my: 4,
            }}
          >
            <Typography
              variant='h4'
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
              }}
            >
              Update - Prepaid Auction Charges
            </Typography>
          </Box>
        </Grid>
        {/* Filters */}
        <Grid item md={11}>
          <Box
            sx={{
              m: '20px 0 20px 0',
              p: '20px',
              bgcolor: Colors.feta,
              border: `1px solid ${Colors.iron}`,
              borderRadius: '9px',
            }}
          >
            <Grid
              container
              spacing={2}
              alignItems={'center'}
              component={'form'}
            >
              <Grid item xs={12} sm={4} >
                <DatePicker
                  size='small'
                  label={'Date'}
                  onChange={handleDateChange}
                  value={selectedDate}
                />
              </Grid>
            </Grid>
          </Box>

          <Box>
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                borderRadius: 2,
                maxHeight: "calc(100vh - 330px)",
                mt: 2,
              }}
              className="table-box"

            >
              <Table stickyHeader sx={{ minWidth: 500 }}>
                <TableHead>
                  <TableRow>
                    <Cell>Customer</Cell>
                    <Cell>VIN</Cell>
                    <Cell>LOT</Cell>
                    <Cell>Make</Cell>
                    <Cell>Model</Cell>
                    <Cell>Shipping Vendor</Cell>
                    <Cell sx={{ width: "10%" }}>LP$</Cell>
                    <Cell sx={{ width: "10%" }}>STG$</Cell>
                    <Cell sx={{ width: "10%" }}>Courier Charges$</Cell>
                    <Cell sx={{ width: "15%" }}>Paid By</Cell>
                    <Cell>Total$</Cell>
                    <Cell>Notes</Cell>
                    <Cell>Action</Cell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.length > 0 ? (
                    rows.map((row) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          bgcolor: rows.indexOf(row) % 2 !== 0 ? '#EFF8E7' : 'inherit',

                        }}
                      >
                        <Cell>{row?.booking?.customer?.name}</Cell>
                        <Cell>{row?.booking?.vin}</Cell>
                        <Cell>{row?.booking?.lot_number}</Cell>
                        <Cell>{row?.booking?.veh_make?.name}</Cell>
                        <Cell>{row.booking?.veh_model?.name}</Cell>
                        <Cell>{row?.booking?.shipping_vendor}</Cell>
                        <Cell sx={{ width: "10%" }}>
                          <InputField
                            size="small"
                            type="number"
                            value={row.late_payment}
                            onInput={(e) => handleLPSChange(row.id, parseFloat(e.target.value))}
                          />
                        </Cell>
                        <Cell sx={{ width: "10%" }}>
                          <InputField
                            size="small"
                            type="number"
                            value={row.storage}
                            onInput={(e) => handleSTGSChange(row.id, parseFloat(e.target.value))}
                          />
                        </Cell>
                        <Cell sx={{ width: "10%" }}>
                          <InputField
                            size="small"
                            type="number"
                            value={row.courier_charges}
                            onInput={(e) => handleCourierChargesChange(row.id, parseFloat(e.target.value))}
                          />
                        </Cell>
                        <Cell sx={{ width: "15%" }}>

                          <SelectField
                            size={'small'}
                            placeholder="Paid By"
                            options={[
                              {
                                "id": "vendor",
                                "name": "Vendor"
                              },
                              {
                                "id": "vbi",
                                "name": "VBI"
                              }
                            ]}
                            value={selectedPaidBy?.name}
                            selected={selectedPaidBy}
                            onSelect={(value) => setSelectedPaidBy(value)}
                            error={errors?.paidBy?.message}
                            register={register("paidBy", {
                              required: 'Please select Paid By.',
                            })}
                          />
                        </Cell>
                        <Cell>{parseFloat(row.total).toFixed(2)}</Cell>
                        <Cell><Box
                          component={"div"}
                          onClick={() => handleEditClick(row)}
                        >
                          <EditIcon />
                        </Box></Cell>
                        <Cell> <IconButton onClick={() => handleDelete(row?.booking?.vin)} color="error">
                          <Delete />
                        </IconButton></Cell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <Cell colSpan={9} align="center" sx={{ fontWeight: 600 }}>
                        No Data Found
                      </Cell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>

        {/* Submit Button */}
        <Grid item md={11} justifyContent="end">
          <Box
            sx={{
              mt: "28px",
              mb: "28px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <PrimaryButton onClick={UpdateSLPVehicles} title="Update" loading={loading} />
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default UpdatePrepaidAuctionCharges;